import React from 'react';

/**
 * Cockpit SegmentedControl — compact view switcher (Table · Focus, etc).
 */
export interface SegmentedOption {
  id: string;
  label: React.ReactNode;
}

export interface SegmentedControlProps {
  options: SegmentedOption[];
  value: string;
  onChange: (id: string) => void;
  style?: React.CSSProperties;
}

export default function SegmentedControl({ options, value, onChange, style }: SegmentedControlProps) {
  return (
    <div
      className="ck-segmented"
      style={{
        display: 'inline-flex',
        gap: '2px',
        padding: '3px',
        background: 'var(--surface-raised)',
        border: '1px solid var(--border-hairline)',
        borderRadius: 'var(--radius-sm)',
        ...style,
      }}
    >
      {options.map((opt) => {
        const isActive = opt.id === value;
        return (
          <button
            key={opt.id}
            className="pressable"
            onClick={() => onChange(opt.id)}
            style={{
              border: 'none',
              borderRadius: '6px',
              padding: '5px 12px',
              flexShrink: 0,
              whiteSpace: 'nowrap',
              fontFamily: 'var(--font-ui)',
              fontSize: 'var(--text-sm)',
              fontWeight: (isActive ? 'var(--weight-medium)' : 'var(--weight-regular)') as React.CSSProperties['fontWeight'],
              background: isActive ? 'var(--surface-active)' : 'transparent',
              color: isActive ? 'var(--text-body)' : 'var(--text-muted)',
              cursor: 'pointer',
              transition: 'background var(--dur-base) var(--ease-out), color var(--dur-base) var(--ease-out)',
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
